import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
/**
 * Provides the link provider context via the legacy context adapter
 * and children render function
 */
// eslint-disable-next-line @repo/internal/react/no-class-components
export var CardContextProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(CardContextProvider, _React$Component);
  var _super = _createSuper(CardContextProvider);
  function CardContextProvider() {
    _classCallCheck(this, CardContextProvider);
    return _super.apply(this, arguments);
  }
  _createClass(CardContextProvider, [{
    key: "render",
    value:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    function render() {
      var _this$context$context;
      var cardContext = this.context.contextAdapter ? (_this$context$context = this.context.contextAdapter.card) === null || _this$context$context === void 0 ? void 0 : _this$context$context.value : undefined;
      return this.props.children({
        cardContext: cardContext
      });
    }
  }]);
  return CardContextProvider;
}(React.Component);
_defineProperty(CardContextProvider, "contextTypes", {
  contextAdapter: PropTypes.object
});